









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import {
  PATIENT_TYPES,
  PATIENT_NEWBORN_TYPES,
} from '@/settings/consts/patient';

@Component
export default class PrescriptionTemplateResumePacient extends BaseComponent {
  @Prop()
  public prescricao: any;

  @Prop()
  public resumeProducts: any;

  public currentTotalVolume: number = 0;
  public patientTypes: any = {};
  public patientNewbornTypes: any = {};

  @Watch('resumeProducts')
  public onResumeProductChange() {
    this.updateCurrentTotalVolume(this.resumeProducts);
  }

  public beforeMount(): void {
    this.getPatientTypes();
  }

  public updateCurrentTotalVolume(resumeProducts: any): number {
    this.currentTotalVolume = 0;
    if (!resumeProducts.length) {
      return;
    }
    return (this.currentTotalVolume = resumeProducts.reduce(
      (total, product) => {
        return total + parseFloat(product.unidadeMedidasProduto[0].valor);
      },
      0,
    ));
  }

  public formatValue(value: number): string {
    return decimalFormat(value);
  }

  public calcQSPWater(desejado, digitado): string {
    return this.formatValue(Math.max(desejado - digitado, 0));
  }

  private getPatientTypes(): void {
    this.patientTypes = PATIENT_TYPES;
    this.patientNewbornTypes = PATIENT_NEWBORN_TYPES;
  }
}
